import { render, staticRenderFns } from "./ayande.vue?vue&type=template&id=8ff2c466"
import script from "./ayande.vue?vue&type=script&lang=js"
export * from "./ayande.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports